import { createFileRoute } from "@tanstack/react-router";

import { EventRulesPage } from "@/features/zdalny-dostep/event-rules-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/reguly-zdarzen")({
	component: EventRulesPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.zdalny-dostep.reguly-zdarzen",
			location.pathname,
		);
	},
});
